import { apiClient } from "./ApiClient";

async function handleResponse(response, defaultMessage) {
  let data = null;
  try {
    data = await response.data;
  } catch {}

  if (response.status >= 400) {
    const detail = data?.detail || defaultMessage;
    throw new Error(detail);
  }

  return data;
}

const MyAccountService = {
  async getUserData(userId) {
    const encodedEmail = encodeURIComponent(userId);
    const response = await apiClient.get(`/user/${encodedEmail}`);
    return handleResponse(response, "Failed to fetch user data");
  },

  async updateUserData({ email, old_password, new_password, username }) {
    const response = await apiClient.put("/user/update", {
      email,
      old_password,
      new_password,
      username,
    });
    return handleResponse(response, "Failed to update user data");
  },

  async deleteUser(userEmail) {
    const response = await apiClient.delete(`/user/${encodeURIComponent(userEmail)}`);
    return handleResponse(response, "Failed to delete user");
  },
};

export default MyAccountService;
